import React from "react";

const CardWhy = (props) => {
  const { icone, title, description } = props.why;
  return (
    <div className="flex flex-col items-center px-9 py-9  bg-white rounded-3xl shadow-lg max-md:px-5 max-md:mt-10">
      <img
        loading="lazy"
        className="aspect-square w-[62px]"
        alt="icone"
        src={icone}
      />
      <div className="mt-7 text-xl font-bold text-primary">{title}</div>
      <div className="self-stretch mt-7 text-sm text-center text-gray-600 md:w-[272px] w-[222px] ">
        {description}
      </div>
    </div>
  );
};

export default CardWhy;
